@if (loading) {
  <payments-loading-section></payments-loading-section>
}
@if (!loading) {
  <ng-content></ng-content>
}